/*
 * URDILE HEADER ENHANCEMENTS
 * - Dropdown desktop: click toggle + cierre al click fuera
 * - Search overlay: open/close + ESC + atajo "/"
 * Header sticky completo (sin auto-hide, sin colapso de barra azul).
 */
(function() {
  'use strict';

  document.addEventListener('DOMContentLoaded', function() {
    initDesktopDropdowns();
    initSearchOverlay();
  });

  // ============================================================
  // DESKTOP DROPDOWNS
  // ============================================================
  function initDesktopDropdowns() {
    var triggers = document.querySelectorAll('[data-dropdown-toggle]');
    if (!triggers.length) return;

    triggers.forEach(function(btn) {
      var item = btn.closest('.site-nav__item--has-dropdown');
      if (!item) return;

      btn.addEventListener('click', function(e) {
        e.preventDefault();
        var isOpen = item.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');

        document.querySelectorAll('.site-nav__item--has-dropdown.is-open').forEach(function(other) {
          if (other !== item) {
            other.classList.remove('is-open');
            var t = other.querySelector('[data-dropdown-toggle]');
            if (t) t.setAttribute('aria-expanded', 'false');
          }
        });
      });

      item.addEventListener('keydown', function(e) {
        if (e.key === 'Escape') {
          item.classList.remove('is-open');
          btn.setAttribute('aria-expanded', 'false');
          btn.focus();
        }
      });
    });

    document.addEventListener('click', function(e) {
      if (!e.target.closest('.site-nav__item--has-dropdown')) {
        document.querySelectorAll('.site-nav__item--has-dropdown.is-open').forEach(function(item) {
          item.classList.remove('is-open');
          var t = item.querySelector('[data-dropdown-toggle]');
          if (t) t.setAttribute('aria-expanded', 'false');
        });
      }
    });
  }

  // ============================================================
  // SEARCH OVERLAY
  // ============================================================
  function initSearchOverlay() {
    var trigger = document.getElementById('SearchTrigger');
    var overlay = document.getElementById('SearchOverlay');
    if (!trigger || !overlay) return;

    var input = overlay.querySelector('[data-search-input]');
    var closeBtns = overlay.querySelectorAll('[data-search-close]');

    function open() {
      overlay.classList.add('search-overlay--open');
      trigger.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
      setTimeout(function() { if (input) input.focus(); }, 50);
    }

    function close() {
      overlay.classList.remove('search-overlay--open');
      trigger.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
      trigger.focus();
    }

    trigger.addEventListener('click', function(e) {
      e.preventDefault();
      open();
    });

    closeBtns.forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        close();
      });
    });

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && overlay.classList.contains('search-overlay--open')) close();
    });

    document.addEventListener('keydown', function(e) {
      if (e.key === '/' && !overlay.classList.contains('search-overlay--open')) {
        var tag = (document.activeElement && document.activeElement.tagName) || '';
        var editable = document.activeElement && document.activeElement.isContentEditable;
        if (tag !== 'INPUT' && tag !== 'TEXTAREA' && tag !== 'SELECT' && !editable) {
          e.preventDefault();
          open();
        }
      }
    });
  }
})();
